import { Button, Icon } from 'semantic-ui-react'
import React, { useState } from 'react';
import firebase from "firebase/app";
import { firestore } from '../App';

function GameButton({ UpdateScore, isAI , isSender, docRef }) {

  const [buttonState, SetButtonState] = useState("");
  const [ColorbuttonState, SetColorButtonState] = useState("purple"); //mediumorchid
  const messagesRef = firestore.collection('messages');
  const incrementAI = firebase.firestore.FieldValue.increment(1)
  const incrementHuman = firebase.firestore.FieldValue.increment(1)
  

  const PlayerSelectedAI = () => {

    if (isAI === "yes") {
      UpdateScore(1);
      SetColorButtonState("green");

    }
    if (isAI === "trueAI") {

      UpdateScore(10);
      SetColorButtonState("yellow");
    }
    if (isAI === "no") {
      UpdateScore(-1);
      SetColorButtonState("red");
    }
    
    SetButtonState("buttonUsed");

    messagesRef.doc(docRef).update({guessedAI: incrementAI});
  }

  const PlayerSelectedHuman = () => {

    if (isAI === "yes") {
      UpdateScore(-1);
      SetColorButtonState("red");

    }
    if (isAI === "trueAI") {

      UpdateScore(-10);
      SetColorButtonState("violet");
    }
    if (isAI === "no") {
      UpdateScore(1);
      SetColorButtonState("green");
    }
    
    SetButtonState("buttonUsed");
    messagesRef.doc(docRef).update({guessedHuman: incrementHuman});
  }

  return (
    <>
    <div>
      <Button  disabled={buttonState} color={ColorbuttonState} style={{ textAlign: "center",marginRight: 4, marginLeft: 4, marginTop: 4 , display: isSender}}
        size="mini" animated onClick={() => PlayerSelectedAI()}>
        <Button.Content visible >yes AI</Button.Content>
        <Button.Content hidden>
          <Icon name='arrow right' />
        </Button.Content>
      </Button>
      <Button  disabled={buttonState} color={ColorbuttonState} style={{ textAlign: "center",marginRight: 4, marginLeft: 4, marginTop: 4 , display: isSender}}
        size="mini" animated onClick={() => PlayerSelectedHuman()}>
        <Button.Content visible >not AI</Button.Content>
        <Button.Content hidden>
          <Icon name='arrow right' />
        </Button.Content>
      </Button>
      

      </div>
      
      
      
    </>
  )
}

export default GameButton;